import axios from "axios";

const baseUrl = import.meta.env.VITE_API_URL;

const hvpPublicApi = axios.create({
  baseURL: baseUrl,
});

export default hvpPublicApi;
